import { useToggle } from "@/hooks/utils/useToggle";
import { Popup } from "components/common/Popup/Popup";
import { translateFunc } from "@/utils/translateFunc";
import { UserIcon } from "lucide-react";
import { DesktopNavDropdownItem } from "components/modules/Navigation/Navbar/Account/Desktop/DesktopNavDropdownItem";
import { useAccountNavigation } from "components/modules/Navigation/Navbar/Account/useAccountNavigation";
import { ArrowIcon } from "@/components/common/Icons/ArrowIcon";

export const UserSettingsDropdown = () => {
    const { isOpen, onClose: onClose, open } = useToggle();
    const { navLinks } = useAccountNavigation();
    return (
        <Popup
            isOpen={isOpen}
            close={onClose}
            content={
                <div
                    onMouseLeave={onClose}
                    onClick={open}
                    onMouseEnter={open}
                    className="absolute pt-4 min-w-[160px] right-0"
                >
                    <div className="flex flex-col top-full bg-white dark:bg-darkSurface-200 dark:highlight-white/5 rounded-md shadow-lg overflow-hidden">
                        {navLinks.map((link) => (
                            <DesktopNavDropdownItem
                                key={link.titleKey}
                                title={translateFunc(link.titleKey)}
                                url={link.url}
                                onClick={link.onClick}
                            />
                        ))}
                    </div>
                </div>
            }
        >
            <button
                aria-label={translateFunc("common:open-theme-popup")}
                onClick={open}
                onMouseLeave={onClose}
                onMouseEnter={open}
                className="ml-2 items-center gap-2 [body[data-is-logged-in=true]_&]:flex hidden"
            >
                <div className="bg-gray-200 dark:bg-gray-900/50 p-1 rounded-full">
                    <UserIcon className="text-black dark:text-white" width={20} height={20} />
                </div>
                <div className={`${isOpen ? "rotate-180" : ""}`}>
                    <ArrowIcon />
                </div>
            </button>
        </Popup>
    );
};
